import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {TreatmentDataService} from './impl/service/ngrx/treatmentData.service';
import {TreatmentRepository} from './impl/service/ngrx/treatment.repository';
@NgModule()
export class TreatmentCommonModule {

    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: TreatmentDataService,
                service: TreatmentRepository,
    ) {

        entityDataService.registerServices({
            Treatment: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Treatment: service,
        });
    }
}
